import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of, EMPTY } from 'rxjs';
import { AuthService } from '@portal/app/shared/services/auth.service';
import { catchError, map } from 'rxjs/operators';
import { SelectionService } from '@portal/app/shared/services/selection.service';

@Injectable({
  providedIn: 'root'
})
export class SelectionResolver
  implements Resolve<{ clientId: number; brandId: number }>
{
  constructor(
    private authService: AuthService,
    private selectionService: SelectionService
  ) {}

  resolve(): Observable<{ clientId: number; brandId: number }> {
    if (this.selectionService.hasSelection()) {
      const { clientId, brandId } =
        this.selectionService.getClientIdAndBrandId();

      return of({ clientId, brandId });
    }

    return this.authService.setFirstClientAndBrand().pipe(
      map(() => {
        const { clientId, brandId } =
          this.selectionService.getClientIdAndBrandId();

        return { clientId, brandId };
      }),
      catchError((error) => {
        console.error('SelectionResolver: Error setting selection', error);
        return EMPTY;
      })
    );
  }
}
